import React, { useContext, useEffect } from "react";
import { DataTable } from "@/components/DataTable";
import { Button } from "@/components/ui";
import { useTranslation } from "react-i18next";
import { DashInvite } from "@/__generated__/graphql";
import { Row } from "@tanstack/react-table";
import { RemoveButton } from "@/components/RemoveButton";
import { InviteTableContext } from "./InviteTable";
import { useMutation } from "@apollo/client";
import { DESTROY_INVITE_MUTATION } from "@/api/mutations/destroyInvite";
import { toast } from "sonner";
import { RESEND_INVITE_MUTATION } from "@/api/mutations/resendInvite";

export const InivteTableActions = ({
  row,
}: {
  row: Row<Partial<DashInvite> | null>;
}) => {
  const { t } = useTranslation();
  const { id } = row.original || {};
  const { refetch } = useContext(InviteTableContext);

  const [destroyInvite, { data: destroyData }] = useMutation(
    DESTROY_INVITE_MUTATION,
  );

  useEffect(() => {
    if (destroyData?.destroyDashInviteMutation?.errors?.length) {
      const { errors } = destroyData?.destroyDashInviteMutation ?? {};
      toast.error(t("teamManagement.table.invited.delete.error"), {
        description: errors?.map(({ message }) => message).join(", "),
      });
    } else if (destroyData?.destroyDashInviteMutation) {
      toast.success(t("teamManagement.table.invited.delete.success"));
      if (refetch) {
        refetch();
      }
    }
  }, [destroyData, refetch, t]);

  const [resendInvite, { data: resendData }] = useMutation(
    RESEND_INVITE_MUTATION,
  );

  useEffect(() => {
    if (resendData?.resendDashInviteMutation?.errors?.length) {
      const { errors } = resendData?.resendDashInviteMutation ?? {};
      toast.error(t("teamManagement.table.invited.resend.error"), {
        description: errors?.map(({ message }) => message).join(", "),
      });
    } else if (resendData?.resendDashInviteMutation) {
      toast.success(t("teamManagement.table.invited.resend.success"));
    }
  }, [resendData, t]);

  return (
    <DataTable.TBodyCell>
      <div className="flex items-center justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          onClick={() =>
            id && resendInvite({ variables: { dashInviteId: id } })
          }
        >
          {t("teamManagement.table.resend")}
        </Button>
        <RemoveButton
          alertTitle={t("teamManagement.table.invited.delete.title")}
          alertDescription={t(
            "teamManagement.table.invited.delete.description",
          )}
          deleteAction={() =>
            id && destroyInvite({ variables: { dashInviteId: id } })
          }
        />
      </div>
    </DataTable.TBodyCell>
  );
};
